"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.LoginStep = void 0;
const redux_1 = require("redux");
const actions_1 = require("../scheduler/actions");
const actions_2 = require("./actions");
const constants_1 = require("./constants");
var LoginStep;
(function (LoginStep) {
    LoginStep["INITIAL"] = "INITIAL";
    LoginStep["PASSWORD"] = "PASSWORD";
    LoginStep["GOOGLE"] = "GOOGLE";
    LoginStep["MICROSOFT"] = "MICROSOFT";
    LoginStep["MFA"] = "MFA";
})(LoginStep = exports.LoginStep || (exports.LoginStep = {}));
exports.initialState = {
    isAuthorized: false,
    isLicenseValid: false,
    user: null,
    role: null,
    isFetching: false,
    isFetchingUserData: false,
    isGoogleAuthorizationCodeFetching: false,
    isMicrosoftAuthorizationCodeFetching: false,
    isGoogleLoginFetching: false,
    isMicrosoftLoginFetching: false,
    isPasswordLoginFetching: false,
    isConnectGoogleContactsFetching: false,
    // Login flow state
    loginStep: LoginStep.INITIAL,
    loginEmail: '',
    loginEmailError: '',
    loginPassword: '',
    loginPasswordError: '',
    // SSO state
    ssoEmail: '',
    ssoForm: null,
    ssoEmailError: false,
    isCheckingEmail: false,
    // MFA state
    mfaError: constants_1.MfaError.NONE,
    mfaIsFetching: false,
};
const isAuthorized = (state = exports.initialState.isAuthorized, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_IS_AUTHORIZED:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_FAILURE:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isAuthorized;
        default:
            return state;
    }
};
const isLicenseValid = (state = exports.initialState.isLicenseValid, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_IS_LICENSE_VALID:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isLicenseValid;
        default:
            return state;
    }
};
const user = (state = exports.initialState.user, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_USER:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.user;
        default:
            return state;
    }
};
const role = (state = exports.initialState.role, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_ROLE:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.role;
        default:
            return state;
    }
};
const isFetching = (state = exports.initialState.isFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_REQUEST:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FETCHING:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_FAIL:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FAIL:
        case actions_2.SUMO1UserActionTypes.SET_IS_FETCHING:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetching;
        default:
            return state;
    }
};
const isFetchingUserData = (state = exports.initialState.isFetchingUserData, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_AUTHENTICATION_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isFetchingUserData;
        default:
            return state;
    }
};
const isGoogleAuthorizationCodeFetching = (state = exports.initialState.isGoogleAuthorizationCodeFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_AUTHORIZATION_CODE_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isGoogleAuthorizationCodeFetching;
        default:
            return state;
    }
};
const isGoogleLoginFetching = (state = exports.initialState.isGoogleLoginFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_GOOGLE_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isGoogleLoginFetching;
        default:
            return state;
    }
};
const isMicrosoftAuthorizationCodeFetching = (state = exports.initialState.isMicrosoftAuthorizationCodeFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_AUTHORIZATION_CODE_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isMicrosoftAuthorizationCodeFetching;
        default:
            return state;
    }
};
const isMicrosoftLoginFetching = (state = exports.initialState.isMicrosoftLoginFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_MICROSOFT_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isMicrosoftLoginFetching;
        default:
            return state;
    }
};
const isPasswordLoginFetching = (state = exports.initialState.isPasswordLoginFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_SUCCESS:
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isPasswordLoginFetching;
        default:
            return state;
    }
};
const isConnectGoogleContactsFetching = (state = exports.initialState.isConnectGoogleContactsFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.CONNECT_GOOGLE_CONTACTS_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.CONNECT_GOOGLE_CONTACTS_SUCCESS:
        case actions_2.SUMO1UserActionTypes.CONNECT_GOOGLE_CONTACTS_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isConnectGoogleContactsFetching;
        default:
            return state;
    }
};
const loginStep = (state = exports.initialState.loginStep, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_LOGIN_STEP:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.loginStep;
        default:
            return state;
    }
};
const loginEmail = (state = exports.initialState.loginEmail, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_LOGIN_EMAIL:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.loginEmail;
        default:
            return state;
    }
};
const loginEmailError = (state = exports.initialState.loginEmailError, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_LOGIN_EMAIL_ERROR:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.loginEmailError;
        default:
            return state;
    }
};
const loginPassword = (state = exports.initialState.loginPassword, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_LOGIN_PASSWORD:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.loginPassword;
        default:
            return state;
    }
};
const loginPasswordError = (state = exports.initialState.loginPasswordError, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_LOGIN_PASSWORD_ERROR:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_LOGIN_WITH_PASSWORD_FAIL:
            return action.payload || exports.initialState.loginPasswordError;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.loginPasswordError;
        default:
            return state;
    }
};
const ssoEmail = (state = exports.initialState.ssoEmail, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_SSO_EMAIL:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.ssoEmail;
        default:
            return state;
    }
};
const ssoForm = (state = exports.initialState.ssoForm, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.GET_SSO_FORM_SUCCESS:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_SSO_FORM_FAIL:
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.ssoForm;
        default:
            return state;
    }
};
const ssoEmailError = (state = exports.initialState.ssoEmailError, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.SET_SSO_EMAIL_ERROR:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.GET_SSO_FORM_FAIL:
        case actions_2.SUMO1UserActionTypes.CHECK_EMAIL_FAIL:
            return true;
        case actions_2.SUMO1UserActionTypes.GET_SSO_FORM_REQUEST:
        case actions_2.SUMO1UserActionTypes.CHECK_EMAIL_REQUEST:
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.ssoEmailError;
        default:
            return state;
    }
};
const isCheckingEmail = (state = exports.initialState.isCheckingEmail, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.CHECK_EMAIL_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.CHECK_EMAIL_SUCCESS:
        case actions_2.SUMO1UserActionTypes.CHECK_EMAIL_FAIL:
            return false;
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isCheckingEmail;
        default:
            return state;
    }
};
// MFA reducers
const mfaError = (state = exports.initialState.mfaError, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.MFA_SET_ERROR:
            return action.payload;
        case actions_2.SUMO1UserActionTypes.CONFIRM_MFA_REQUEST:
        case actions_2.SUMO1UserActionTypes.MFA_RESET:
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.mfaError;
        default:
            return state;
    }
};
const mfaIsFetching = (state = exports.initialState.mfaIsFetching, action) => {
    switch (action.type) {
        case actions_2.SUMO1UserActionTypes.CONFIRM_MFA_REQUEST:
            return true;
        case actions_2.SUMO1UserActionTypes.CONFIRM_MFA_SUCCESS:
        case actions_2.SUMO1UserActionTypes.CONFIRM_MFA_FAIL:
        case actions_2.SUMO1UserActionTypes.MFA_RESET:
        case actions_2.SUMO1UserActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.mfaIsFetching;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    isAuthorized,
    isLicenseValid,
    user,
    role,
    isFetching,
    isFetchingUserData,
    isGoogleLoginFetching,
    isMicrosoftLoginFetching,
    isPasswordLoginFetching,
    isGoogleAuthorizationCodeFetching,
    isMicrosoftAuthorizationCodeFetching,
    isConnectGoogleContactsFetching,
    loginStep,
    loginEmail,
    loginEmailError,
    loginPassword,
    loginPasswordError,
    ssoEmail,
    ssoForm,
    ssoEmailError,
    isCheckingEmail,
    mfaError,
    mfaIsFetching,
});
